/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { deleteCard, showCards } from 'js/actions/cardAction';
import { useDispatch, useSelector } from 'react-redux';
import { isAllowed } from 'helpers';
import { Delete, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

export default function CardTable(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cards = useSelector((state) => state.cards.cards);
  const user = useSelector((state) => state.user.user);
  const concentratorid = props.props;

  const [state, setState] = useState({
    columns: [
      { headerName: 'Identificador', field: 'id', flex: 1 },
      { headerName: 'Nombre', field: 'name', flex: 1 },
      { headerName: 'Tipo', field: 'type' },
      { headerName: 'Direccion MAC', field: 'mac_address', flex: 1 },
      {
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        renderCell: (rowData) => {
          const actions = [];
          if (isAllowed(user.permissions, ['card_delete'])) {
            actions.push(
              <Tooltip title={'Eliminar Tarjeta'}>
                <IconButton onClick={() => deleteCardData(rowData.row.id)}>
                  <Delete />
                </IconButton>
              </Tooltip>
            );
          }

          if (isAllowed(user.permissions, ['concentrator_update'])) {
            actions.push(
              <Tooltip title={'Editar Tarjeta'}>
                <IconButton
                  onClick={() =>
                    navigate(`/updateCard/${props.meterId}/${rowData.row.id}`, {
                      state: rowData.row,
                    })
                  }
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            );
          }
          return actions;
        },
      },
    ],
  });

  const deleteCardData = (cardId) => {
    dispatch(deleteCard(cardId));
  };

  useEffect(() => {
    dispatch(showCards(concentratorid));
  }, []);

  useEffect(() => {
    setState({ ...state, data: cards });
  }, [cards]);

  return (
    <Box height={500} width="100%">
      <DataGrid
        rows={state.data}
        columns={state.columns}
        // Deshabilitar la seleccion de filas
        rowSelection={false}
        // Configuración de tabla
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5, // Tamaño de la página
            },
          },
        }}
        slots={{ toolbar: QuickSearchToolbar }} // Usa el componente QuickSearchToolbar para la barra de búsqueda
        sx={{
          pt: 2,
          pb: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: 'background.paper', // Color de fondo de la tabla
          border: '1px solid',
          borderColor: 'divider',
          '& .MuiDataGrid-root': {
            border: 'none', // Quitar borde de la tabla
          },
          '& .MuiDataGrid-cell': {
            borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
            maxHeight: '60px', // Altura máxima de las celdas
          },
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados de columna
          },
          '& .MuiDataGrid-row': {
            borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
            maxHeight: '60px', // Altura máxima de las filas
          },
        }}
      />
    </Box>
  );
}
